import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ModalService } from 'src/services/other/modal.service';
import { UsersService } from 'src/services/users/users.service';

@Component({
  selector: 'app-login-forgotten-password',
  templateUrl: './login-forgotten-password.component.html',
  styleUrls: ['./login-forgotten-password.component.css']
})
export class LoginForgottenPasswordComponent {
  formLogin: FormGroup;
  isOnSubmit: boolean = false;
  isDisabled: boolean = false;
  hidePassword: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private loginService: UsersService,
    private modalService: ModalService,
    private router: Router,
  ) {
    this.formLogin = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    this.isDisabled = true;
    this.isOnSubmit = true;
    
    if (this.formLogin.valid) {
      this.modalService.open("Loading");
      this.loginService.postPasswordRecovery(this.formLogin.value).subscribe({
        next: () => {
          this.isOnSubmit = false;
          this.isDisabled = false;
          this.modalService.isSuccess(true, "SuccessEmailSendInbox");
          setTimeout(() => {
            this.isOnSubmit = false;
            this.isDisabled = false;
            this.modalService.hide();
            this.router.navigate(['/login']);

          }, 3500);
        }, error: () => {
          this.modalService.isError(true, 'Error');
          setTimeout(() => {
            this.isOnSubmit = false;
            this.isDisabled = false;
            this.modalService.hide();
          }, 1500);
        }
      });
    } else {
      this.isDisabled = false;
    }
  }
}
